import styles from "./MarketingTextSection.module.css";

const MarketingTextSection = ({ value, onChange }) => {
  const update = (key, val) => {
    onChange({
      ...value,
      [key]: val
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h4>Marketing Content</h4>
        <span>
          This content may be shown on country landing pages and promotions.
        </span>
      </div>

      <div className={styles.field}>
        <label>Title</label>
        <input
          placeholder="e.g. Discover Belgium"
          value={value.title}
          onChange={e => update("title", e.target.value)}
        />
      </div>

      <div className={styles.field}>
        <label>Paragraph 1</label>
        <textarea
          rows={3}
          placeholder="Short introductory description"
          value={value.para1}
          onChange={e => update("para1", e.target.value)}
        />
      </div>

      <div className={styles.field}>
        <label>Paragraph 2</label>
        <textarea
          rows={3}
          placeholder="Additional marketing details"
          value={value.para2}
          onChange={e => update("para2", e.target.value)}
        />
      </div>
    </div>
  );
};

export default MarketingTextSection;
